<template>
		<div class="flex items-center  flex-row-reverse navbar bg-white p-0 sticky z-50 top-0 left-0 shadow" :class="{ 'w-100': isSidebarToggle, 'w-200': !isSidebarToggle }">
		<!-- <div class="w-40 flex items-center">
			<div class="lg:flex mx-2 cursor-pointer" @click="ontoggle()">
				<img src="@/assets/menu.svg" class="h-4 w-5 cursor-pointer" />
			</div>
			 <div class="lg:flex cursor-pointer">
				<span class="text-lg font-bold cursor-pointer">
					<img src="@/assets/crystalline.svg" alt="" class="crystallineLogo" />
				</span>
			</div>
		</div> -->
		<!-- <div class="flex-1 px-2 mx-2 h-full" @click="closeApps()"></div> -->
		<div>
			<div @click="toggleUserDropdown" >
				<img :src="userInfo.picture" class="rounded-full m-1 mr-4 w-8 h-8 cursor-pointer userpicturestyle"  v-if="userInfo.picture"/>
				<div class="m-1 mr-2 w-8 h-8 rounded-full bg-gray text-2xl cursor-pointer" v-else>
					<div class="flex justify-center items-center h-full text-white cursor-pointer">
						{{getUserName()}}
					</div>
				</div>
				<div v-if="showBlock" class="py-1 bg-white absolute right-4  shadow card mt-2.5 w-80">
					<div class="  py-2 text-gray cursor-pointer flex flex-col items-center" >
						<div v-if="userInfo.picture">
							<img :src="userInfo.picture" class="rounded-full m-1 mr-2 w-12 h-12 cursor-pointer userpicturestyle"  >
						</div>
				<div class="m-1 mr-2 w-12 h-12 rounded-full bg-gray text-2xl cursor-pointer" v-else>
					<div class="flex justify-center items-center h-full text-white cursor-pointer">
						{{getUserName()}}
					</div>
					
				</div>
						<div class="px-4 text-sm text-black font-semibold  mt-2 capitalize">{{userInfo.name}}</div>
						<div class="px-4 text-xs mt-1">
						{{userInfo.email}}
					</div>
						<div class=" border-b border-solid border-lightgrey w-full mt-2"></div>
							<!-- <p v-if="displayName" class="text-black font-semibold mt-2 text-sm capitalize">{{displayName}}</p> -->
							<p class="inline-block text-black font-semibold mt-2 text-sm">Global</p>
							<div class="flex items-center text-gray-normal text-xs px-4 mt-1 mb-2">
								Session Expires In: {{ formattedRemainingTime }}
							</div>
							<div class=" border-b border-solid border-lightgrey w-full"></div>
							<div class="flex justify-center items-center mt-2">
								<button class="filterButton flex mt-1 logout" @click="logout()">
								Log Out
								</button>
							</div>
					</div>
				</div>
			</div>
		</div>
		<div class="relative pr-4 pl-2.5 cursor-pointer " ref="dropdownContainer" @click="showMenuBlock=!showMenuBlock">
			<div class=" cursor-pointer rounded transition-colors duration-200 menubackgroundstyle" :class="showMenuBlock ? 'bg-[#adadad]' : 'hover:bg-lightgrey'" @click="toggleDropdown">
				<img src="@/assets/menuIcon.svg" class="menuIcon cursor-pointer" />
			</div>	
			<div v-if="showMenuBlock " class="absolute menucard1 right-2 bg-white border p-3 flex justify-end flex-wrap gap-5 flex-row-reverse" >
				<div v-for="item in items" :key="item.name"  class="menucard" @click="selectItem(item)">
					<img :src="item.icon" alt="icon" class="icon" />
					<p>{{ item.name }}</p>
				</div>
			</div>
		</div>
	</div>
</template>
<style scoped>
.menubackgroundstyle{
	width: 36px;
    height: 36px;
    border-radius: 32px;
    display: flex;
    align-items: center;
	justify-content: center;
}
.menucard1{
	width: 310px;
    border-radius: 10px;
    border-width: 2px;
    margin-top: 12px;
    border-color:var(--color-lightgrey);
 
}
.menucard {
  background: #fff;
  text-align: center;
  height: 80px;
  width: 80px;
  cursor: pointer;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: 600;

}

.menucard:hover {
  background-color: var(--color-lightgrey);
  border-radius: 10px;
}
.rounded-full:hover{
	box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.1);
}
.navbar{
	min-height: 2.5rem;
	height: 48px;
	 position:fixed;
    width: 100%;
}

.right-4{
	box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.08);
	/* background-color: red; */
}
.crystallineLogo{
	width:120px;
	margin-top:2px;
}

.logout:hover{
	background-color: var(--color-primary);
    border: 1px solid var(--color-primary);
    color: #ffffff;
}
.w-200{
	width: 100%;
}
.menuIcon{
	width: 24px !important;
	height: 24px !important;
}
.userpicturestyle{
	border: 1px solid var(--color-lightgrey);
}
</style>
<script lang="ts">
import { defineComponent } from 'vue';
import { emitter,toast } from '../main';
import { mapGetters } from 'vuex';
export default defineComponent({
	computed: {
		...mapGetters({ userInfo: 'userInfo' }),
		// filteredItems():any{
        //     if (this.userInfo.organisationId === 'Global') {
        //         return this.items.filter((item:any)=>
        //         item.name === 'Monitor' || item.name === 'Risk' || item.name === 'Training'
        //         );
        //     }
        //     return this.items;
        // },
		getlocation() {
			return window.location.origin;
		}
	},
	data():any {
		return {
			showMenuBlock:false,
			isToggle: true,
			isappsToggle:false,
			showBlock: false,
			displayName:'',
			formattedRemainingTime: 'Loading...', // For displaying remaining time
			timerInterval: null as any ,// Store interval reference,
			warningTime : `${process.env.VUE_APP_WARNING_TIME}`,
			items: [
				{
                    id:10001,
					name: 'Monitor',
					icon: require('@/assets/monitorLogo.svg'),
				},
				{
                    id:10006,
					name: 'DMS',
					icon: require('@/assets/dmsLogo.svg'),

				},
                {
                    id:10004,
					name: 'Audit',
					icon: require('@/assets/auditLogo.svg'),
				},
                {
                    id:10002,
					name: 'Training',
					icon: require('@/assets/trainingLogo.svg'),
				},
				{   id:10003,
					name: 'Risk',
					icon: require('@/assets/riskLogo.svg'),
				},
                {
                    id:10007,
					name: 'Planner',
					icon: require('@/assets/plannerLogo.svg'),  

				},
				
			],
		};
	},
	methods: {
		closeApps(){
			this.isappsToggle=false;
			this.showBlock=false;
			emitter.emit('apps-sidemenubar',this.isappsToggle);
		},
		ontoggle() {
			this.isappsToggle = !this.isappsToggle;
			this.showBlock=false;
			emitter.emit('apps-sidemenubar', this.isappsToggle);
		},

		getUserName(){
			return this.userInfo.name.charAt(0).toUpperCase()
		},
		
		async logout() {
            var payload = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('AUTH_ID')
                }
            };
            await this.$http
                .post(`${process.env.VUE_APP_AUTH_API}/logout`, payload)
                .then((response: any) => {
                    if (response.status == 200) {
                        toast.success(`Logout Successfully`, {
                            timeout: 1000,
                            closeOnClick: true,
                            closeButton: 'button',
                            icon: true
                        });
                    }
                })
                .catch((error: any) => {
                    toast.error(`Save failed with ${error}`, {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
                });
 
            localStorage.removeItem('AUTH_ID');
            window.location.replace(`${process.env.VUE_APP_AUTH_UI}/logout?returnTo=${process.env.VUE_APP_ADMIN_UI}`);
        },
		async getAllTenants() {
			await this.$http.get(`${process.env.VUE_APP_AUTH_API}/tenants/getAll`).then((res: any) => {
				this.allTenants = res.data;
				this.allTenants.filter((tenant:any) => {
					let userDomain = this.userInfo.email.substring(this.userInfo.email.lastIndexOf("@") + 1);
					let userOrgDetails = userDomain.split('.')[0];
					if(this.userInfo.organisationType==10701){
						this.displayName=this.userInfo.organizationName
					}
					if( tenant.tenantName!= undefined && userOrgDetails.toLowerCase() == tenant.tenantName.toLowerCase()){
						this.displayName= tenant.displayName
					}
					
				});
			});
		},
		async selectItem(item:any) {
      		this.selectedItem = false
			const appName = item.name.toLowerCase();
			if(item.id == 10001) {
				if(this.userInfo.organisationType==10702){
				    window.open(`${process.env.VUE_APP_AUTH_UI}/session?returnTo=${process.env.VUE_APP_MONITOR_UI}`,'_blank');
                }
                else{
					await this.$http.get(`${process.env.VUE_APP_AUTH_API}/getActiveSession/${appName}`).then((result: any) => {
						const res:any = result.data
						window.open(`${process.env.VUE_APP_AUTH_UI}/token?access_token=${res.access_token}&id_token=${res.id_token}&refresh_token=${res.refresh_token}&expires_at=${res.expires_at}&provider=${res.provider}&returnTo=${process.env.VUE_APP_MONITOR_UI}`);	
					}); 
				}
			}
			if(item.id == 10006) {
				if(this.userInfo.organisationType==10702){
				    window.open(`${process.env.VUE_APP_AUTH_UI}/session?returnTo=${process.env.VUE_APP_DMS_UI}`,'_blank');
                }
                else{
					await this.$http.get(`${process.env.VUE_APP_AUTH_API}/getActiveSession/${appName}`).then((result: any) => {
						const res:any = result.data
						window.open(`${process.env.VUE_APP_AUTH_UI}/token?access_token=${res.access_token}&id_token=${res.id_token}&refresh_token=${res.refresh_token}&expires_at=${res.expires_at}&provider=${res.provider}&returnTo=${process.env.VUE_APP_DMS_UI}`);
					});   
				}
			}
			if(item.id == 10004) {
				if(this.userInfo.organisationType==10702){
				    window.open(`${process.env.VUE_APP_AUTH_UI}/session?returnTo=${process.env.VUE_APP_AUDIT_UI}`,'_blank');
                }
                else{
					await this.$http.get(`${process.env.VUE_APP_AUTH_API}/getActiveSession/${appName}`).then((result: any) => {
						const res:any = result.data
						window.open(`${process.env.VUE_APP_AUTH_UI}/token?access_token=${res.access_token}&id_token=${res.id_token}&refresh_token=${res.refresh_token}&expires_at=${res.expires_at}&provider=${res.provider}&returnTo=${process.env.VUE_APP_AUDIT_UI}`);
					}); 
				}
			}
			if(item.id == 10002) {
				if(this.userInfo.organisationType==10702){
				    window.open(`${process.env.VUE_APP_AUTH_UI}/session?returnTo=${process.env.VUE_APP_TRAINING_UI}`,'_blank');
                }
                else{
					await this.$http.get(`${process.env.VUE_APP_AUTH_API}/getActiveSession/${appName}`).then((result: any) => {
						const res:any = result.data
						window.open(`${process.env.VUE_APP_AUTH_UI}/token?access_token=${res.access_token}&id_token=${res.id_token}&refresh_token=${res.refresh_token}&expires_at=${res.expires_at}&provider=${res.provider}&returnTo=${process.env.VUE_APP_TRAINING_UI}`);
					});
                }
			}
			if(item.id == 10003) {
				if(this.userInfo.organisationType==10702){
				    window.open(`${process.env.VUE_APP_AUTH_UI}/session?returnTo=${process.env.VUE_APP_RISK_UI}`,'_blank');
                }
                else{
					await this.$http.get(`${process.env.VUE_APP_AUTH_API}/getActiveSession/${appName}`).then((result: any) => {
						const res:any = result.data
						window.open(`${process.env.VUE_APP_AUTH_UI}/token?access_token=${res.access_token}&id_token=${res.id_token}&refresh_token=${res.refresh_token}&expires_at=${res.expires_at}&provider=${res.provider}&returnTo=${process.env.VUE_APP_RISK_UI}`);
					}); 
				}
			}
			if(item.id == 10007) {
				if(this.userInfo.organisationType==10702){
				    window.open(`${process.env.VUE_APP_AUTH_UI}/session?returnTo=${process.env.VUE_APP_PLANNER_UI}`,'_blank');
                }
                else{
					await this.$http.get(`${process.env.VUE_APP_AUTH_API}/getActiveSession/${appName}`).then((result: any) => {
						const res:any = result.data
						window.open(`${process.env.VUE_APP_AUTH_UI}/token?access_token=${res.access_token}&id_token=${res.id_token}&refresh_token=${res.refresh_token}&expires_at=${res.expires_at}&provider=${res.provider}&returnTo=${process.env.VUE_APP_PLANNER_UI}`);
					}); 
				}
			}
    	},
		toggleDropdown(event: MouseEvent) {
			event.stopPropagation();
			this.showMenuBlock = !this.showMenuBlock;
			if (this.showBlock==true) {
				 this.showBlock = false;
			}
            
		},
        toggleUserDropdown(){
            if(this.showMenuBlock == true) {
                this.showMenuBlock = false;
            }
             this.showBlock=!this.showBlock
             
        },
		updateRemainingTime() {
			if (!this.userInfo.expires) return;

			const update = () => {
				const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
				const expiresTime = this.userInfo.expires; // Expiration time in seconds
				const remainingTime = expiresTime - currentTime; // Remaining time in seconds

				if (remainingTime <= 0) {
					this.formattedRemainingTime = 'Session Expired';
					clearInterval(this.timerInterval);
					emitter.emit('updateFormattedRemainingTime', this.formattedRemainingTime);
					return;
				}

				// Convert remaining time into hh:mm:ss format
				const hours = Math.floor(remainingTime / 3600);
				const minutes = Math.floor((remainingTime % 3600) / 60);
				const seconds = remainingTime % 60;

				this.formattedRemainingTime = `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;


				const [hrs, mins, secs] = this.formattedRemainingTime.split(':').map(Number); // Split and convert to numbers
           	 	const totalSeconds = (hrs * 3600) + (mins * 60) + secs;
				const warningTimerSec = this.warningTime*60;
				if(totalSeconds <=warningTimerSec){
					emitter.emit('updateFormattedRemainingTime', this.formattedRemainingTime);
					emitter.emit('showPopup',true);

				}
			};

			update(); // Call once immediately
			this.timerInterval = setInterval(update, 1000); // Update every second
		},
	},

	mounted() {
		this.getAllTenants();
		this.updateRemainingTime(); // Start countdown timer
		emitter.on("apps",(isToggle:any)=>{
			this.showBlock = isToggle
			this.isappsToggle = isToggle;
		    this.showMenuBlock=isToggle;

		});
		emitter.on('session-extended', (newExpires: any) => {
			this.userInfo.expires = newExpires;
			this.updateRemainingTime();
		});
	},
	beforeUnmount() {
		if (this.timerInterval) {
			clearInterval(this.timerInterval); // Clear interval when component unmounts
		}
	}
});
</script>